import React, {useState, useEffect} from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import { NumericFormat } from 'react-number-format';
import moment from 'moment';
import _ from "lodash";


function ModalDashboardNominals( {handleOpen, isOpen, listOperations}) {

    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>Nominales</DialogTitle>
                <Divider />
                <DialogContent>
                    <table className="table table-sm table-hover table-striped" >
                        <thead style={{backgroundColor: '#FFFFFF'}}>
                            <tr className="text-nowrap">
                                <th>Instrumento</th>
                                <th className="text-end">Cantidad</th>
                            </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                            { listOperations && Object.keys(listOperations).sort().map(ticker => {
                                const tickerQty = listOperations[ticker];
                                return (
                                    <tr key={"M"+ticker}>  
                                        <td><span className="fw-medium"><small>{ticker}</small></span></td>                             
                                        <td className="text-end">
                                            <small>
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={tickerQty} 
                                                    allowLeadingZeros thousandSeparator="." 
                                                    decimalSeparator="," 
                                                /> 
                                            </small>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
        
                </DialogContent>
                {/* <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-outline-secondary"  onClick={() => handleOpen(false)}> Cerrar </button>                                       
                </DialogActions> */}
            </ModalDialog>
        </Modal>

    );
}

export default ModalDashboardNominals;